export default __webpack_public_path__ + "static/media/stradivarius.d9d21999.png";